import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import * as pathConstants from '../../constants/pathConstants';
import '../../styles/header/header.css';
import ChevronDownWhite from '../icons/chevronDownWhite';
import { generateSubmissionReport } from '../../actions/generateSubmissionReport';

class Menu extends Component {
  constructor(props) {
    super(props);

    // Initial state to control the dropdown visibility
    this.state = {
      dropdownOpen: false
    };

    // Bind the toggle function
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  // Method to toggle the dropdown
  toggleDropdown() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  render() {
    const { authenticated, user, logout, onNavChange, menuTitleShown } = this.props;
    const { dropdownOpen } = this.state;

    return (
      <div className="menu-parent col-xs-12 col-sm-3">
        <div className="menu-title-item pull-right" hidden={menuTitleShown}>
          <label>Injury Tracking Application</label>
          <div>
            {authenticated ? (
              <div>
                <span className="non-mobile">
                  <strong>User:</strong> {user.firstName}
                </span>{" "}
                | <a href="/saml/logout" onClick={logout}>Logout</a>
              </div>
            ) : (
              <Link to={pathConstants.pathToLogin}>Login</Link>
            )}
          </div>
        </div>

        <div className="menu-drop-down pull-right" hidden={!authenticated}>
          <DropdownButton
            title="Navigation Menu"
            key="nav-dropdown"
            id="dropdown-basic"
            open={dropdownOpen} // Control the dropdown's visibility using open (React-Bootstrap v0.30.0 and earlier)
            onToggle={this.toggleDropdown} // Toggle visibility when clicked
          >
            <MenuItem
              className="nav-child"
              eventKey={pathConstants.pathToHome}
              onSelect={onNavChange}
            >
              Go to Home Page
            </MenuItem>
            <MenuItem
              className="nav-child"
              eventKey={pathConstants.pathToEstablishmentsDashboardPage}
              onSelect={onNavChange}
            >
              View Establishment List
            </MenuItem>
            <MenuItem
              className="nav-child"
              eventKey={pathConstants.pathToBulkTransferPage}
              onSelect={onNavChange}
            >
              Bulk Transfer Establishments
            </MenuItem>
            <MenuItem
              className="nav-child"
              eventKey={pathConstants.pathToCreateEstablishmentPage}
              onSelect={onNavChange}
            >
              Create an Establishment
            </MenuItem>
            <MenuItem
              className="nav-child"
              eventKey={pathConstants.pathToFileUploadForm}
              onSelect={onNavChange}
            >
              Upload 300A Data
            </MenuItem>
            <MenuItem
              className="nav-child"
              eventKey={pathConstants.pathToCaseDataFileUploadForm}
              onSelect={onNavChange}
            >
              Upload 300/301 Data
            </MenuItem>
            <MenuItem className="nav-child" onClick={() => generateSubmissionReport()}>
              View Submission Report
            </MenuItem>
            <MenuItem
              className="nav-child"
              eventKey={pathConstants.accountPageBase + pathConstants.pathToAccountPage}
              onSelect={onNavChange}
            >
              Manage My Account
            </MenuItem>
            <MenuItem
              className="nav-child"
              eventKey={pathConstants.accountPageBase + pathConstants.pathToApiTokenPage}
              onSelect={onNavChange}
            >
              View Your API Token
            </MenuItem>
            <MenuItem
              className="nav-child"
              onSelect={() => window.open("https://www.osha.gov/sites/default/files/ita_user_guide.pdf", "_blank")}
            >
              ITA User Guide
            </MenuItem>
            <MenuItem
              className="nav-child"
              eventKey={pathConstants.pathToHelpRequest}
              onSelect={onNavChange}
            >
              Get Help
            </MenuItem>
          </DropdownButton>

          {/* Add onClick to toggle the dropdown when Chevron is clicked */}
          <div className="cursor-pointer" onClick={this.toggleDropdown}>
            <ChevronDownWhite />
          </div>
        </div>
      </div>
    );
  }
}

Menu.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  user: PropTypes.object,
  menuTitleShown: PropTypes.bool.isRequired,
  onNavChange: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired
};

export default Menu;



/** WEBPACK FOOTER **
 ** ./src/components/common/Menu.js
 **/